import * as actionsType from "./types";

// Product Actions
// export const getCategories = () => ({
//     type: actionsType.GET_CATEGORIES,
// })

// export const getSubCategories = (categoryId, categoryIndex) => ({
//     type: actionsType.GET_SUB_CATEGORIES,
//     payload: {
//         categoryId,
//         categoryIndex
//     }
// })

export const getFeaturedProducts = (callback) => ({
    type: actionsType.GET_FEATURED_PRODUCTS,
    payload: { callback }
})

export const setCategories = (list) => ({
    type: actionsType.SET_CATEGORIES,
    payload: {
        categoryList: list
    }
})

export const setSubCategories = (list, categoryIndex) => ({
    type: actionsType.SET_SUB_CATEGORIES,
    payload: {
        subCategoryList: list,
        categoryIndex
    }
})

export const setFeaturedProducts = (list, categoryIndex, subCategoryIndex) => ({
    type: actionsType.SET_FEATURED_PRODUCTS,
    payload: { list, catIndex: categoryIndex, subCategoryIndex }
})

export const getProducts = () => ({
    type: actionsType.GET_PRODUCTS
})

export const setProducts = (details) => ({
    type: actionsType.SET_PRODUCTS,
    payload: details
})


export const getProductsListing = (callback) => ({

    type: actionsType.GET_PRODUCTS_LISTING,
    payload: callback

})

export const getuserProductsListing = (callback) => ({

    type: actionsType.GET_USER_PRODUCTS_LISTING,
    payload: callback

})


export const setProductsListing = (details) => ({
    type: actionsType.SET_PRODUCTS_LISTING,
    payload: details
})

export const fetchProduct = (details) => ({
    type: actionsType.FETCH_PRODUCT
})

export const setCatData = (details) => ({
    type: actionsType.SET_CAT_DATA,
    payload: details
})

export const addProduct = (values) => ({

    type: actionsType.ADD_PRODUCT,
    payload: values

})
export const updateProduct = (values) => ({

    type: actionsType.UPDATE_PRODUCT,
    payload: values
})



export const updateProductDetail = (values) => ({

    type: actionsType.UPDATE_PRODUCT_DETAIL,
    payload: values
})

export const updatesellerProduct = (data) => ({
    type: actionsType.UPDATE_SELLER_PRODUCT,
    payload: data
})


export const getProductsBidding = (callback) => ({

    type: actionsType.GET_PRODUCTS_BIDDING,
    payload: callback
})

export const setProductsBidding = (details) => ({
    type: actionsType.SET_PRODUCTS_BIDDING,
    payload: details
})

export const getCategory = () => ({
    type: actionsType.FETCH_CATEGORY_FIELDS
})



export const addSubCategory = (data) => ({
    type: actionsType.ADD_SUB_CATEGORY,
    payload: data
})

export const addCategory = (data) => ({
    type: actionsType.ADD_CATEGORY,
    payload: data
})


export const updateCategories = (data) => ({

    type: actionsType.UPDATE_CATEGORIES,
    payload: {
        data
    }
})

export const updateSubCategory = (details) => ({
    type: actionsType.UPDATE_SUBCATEGORIES,
    payload: details
})

export const getSubcategory = () => ({
    type: actionsType.FETCH_SUBCATEGORY_FIELDS,

})


export const getProductDetails = (productId, history) => ({
    type: actionsType.GET_PRODUCT_DETAILS,
    payload: {
        productId,
        history
    }
})

export const setProductDetails = (details) => ({
    type: actionsType.SET_PRODUCT_DETAILS,
    payload: { details }
})

export const fetchSubCategoryFields = (details) => ({
    type: actionsType.FETCH_SUBCATEGORY_FIELDS,
    payload: { details }
})

// User Actions Login , Logout etc

export const login = (val) => ({
    type: actionsType.LOGIN,
    payload: val,

})

export const login_success = (user) => ({
    type: actionsType.LOGIN_SUCCESS,
    payload: user,
})

export const logout = () => ({
    type: actionsType.LOGOUT
})

export const logout_success = (user) => ({
    type: actionsType.LOGOUT_SUCCESS,
    payload: { user }
})

export const register = (details) => ({
    type: actionsType.REGISTER,
    payload: details
})

export const register_proceed = (details) => ({
    type: actionsType.REGISTER_PROCEED,
    payload: details
})

export const forgot_password = (details) => ({
    type: actionsType.FORGOT_PASSWORD,
    payload: details
})

export const forgot_password_requested = (details) => ({
    type: actionsType.FORGOT_PASSWORD_REQUESTED,
    payload: details
})
export const forgot_password_success = (details) => ({
    type: actionsType.FORGOT_PASSWORD_SUCCESS,
    payload: details
})
export const forgot_password_failure = (details) => ({
    type: actionsType.FORGOT_PASSWORD_FAILURE,
    payload: details
})


export const update_profile = (details) => ({
    type: actionsType.UPDATE_PROFILE,
    payload: details
})

export const change_password = (details) => ({
    type: actionsType.CHANGE_PASSWORD,
    payload: details
})



// Loaders Actions  

export const show_loader = () => ({
    type: actionsType.SHOW_LOADER,
})

export const hide_loader = () => ({
    type: actionsType.HIDE_LOADER,
})

export const getFilteredProducts = (filters, skip, pageNumber, limit) => ({
    type: actionsType.GET_FILTERED_PRODUCTS,
    payload: {
        filters, skip, pageNumber, limit
    }
})

export const setFilteredProducts = (response, filters, pageNumber) => ({
    type: actionsType.SET_FILTERED_PRODUCTS,
    payload: {
        response, filters, pageNumber
    }
})



// ___________________________________ ADMIN____________________________________



export const getRegisterUsers = (callback) => ({
    type: actionsType.GET_REGISTERED_USER_PROCEED,
    payload: callback
})

export const setRegisterUser = (data) => ({
    type: actionsType.SET_REGISTERED_USER,
    payload: data,
})

export const delRegisterUsers = (data) => ({
    type: actionsType.DEL_REGISTERED_USER,
    payload: data,
})


export const editCategory = (data) => ({
    type: actionsType.EDIT_CATEGORY,
    payload: data,
})

export const editSubCategory = (data) => ({
    type: actionsType.EDIT_SUB_CATEGORY,
    payload: data,
})


export const delCategory = (data) => ({
    type: actionsType.DEL_CATEGORY,
    payload: data,
})


export const delProduct = (data) => ({
    type: actionsType.DEL_PRODUCTS,
    payload: data,
})



export const delSubCategory = (data) => ({
    type: actionsType.DEL_SUB_CATEGORY,
    payload: data,
})

export const updateUserStatus = (data) => ({
    type: actionsType.UPDATE_USER_STATUS,
    payload: data,
})

